import * as React from 'react';
import { MergeOrder, TopModelMergeNameTransformed } from '@goldwasserexchange/react-topmodel';
import { inputFooterDomDefaultTopModelsObject } from '../topModels';

export function DefaultFooterDomTopModelsProvider(
  props: React.PropsWithChildren<{ order?: MergeOrder }>,
) {
  const { children, order } = props;
  return (
    <TopModelMergeNameTransformed
      topModels={inputFooterDomDefaultTopModelsObject}
      order={order}
    >
      {children}
    </TopModelMergeNameTransformed>
  );
}
